import React from 'react';
import { BasicFormModalLayout } from 'modules/components/layer13';
import { RemoveMilestoneForm } from 'modules/components/layer12';

export type RemoveMilestoneModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

export const FC = (props: RemoveMilestoneModalProps) => {

  return (
    <BasicFormModalLayout.FC
      id={props.id}
      title='Remove milestone'
      subTitle='Remove milestone from the system. This can not be undone.'
      handleClose={props.handleClose}
      isVisible={props.isVisible}
    >
      <RemoveMilestoneForm.FC
        id={props.id}
        handleClose={props.handleClose}
      />
    </BasicFormModalLayout.FC>
  );

};
